import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withFirebase } from '../Firebase';
import './HistoricModal.css';
import DefaultProfileImg from '../assets/icon_user_profile.svg';

class HistoricModal extends Component {
    constructor(props) {
        super(props);
        this.state = { historics: [] };
    }

    componentDidMount() {
        let uid;
        if (this.props.firebase.auth.currentUser) {
            uid = this.props.firebase.auth.currentUser.uid
            this.setState({ current_uid: uid })

            this.props.firebase.db
                .collection("capsules")
                .doc(this.props.capsuleId)
                .collection("historic")
                .get()
                .then(querysnapshot => {
                    let historics = querysnapshot.docs.map(doc => {
                        let data = doc.data()
                        return {
                            id: doc.id,
                            ...data
                        }
                    });
                    let sorted = historics.sort((a, b) => b.date - a.date)
                    this.setState({ historics: sorted })
                })
        }
    }

    historicDate = (date) => {
        let current_date = new Intl.DateTimeFormat('fr-FR', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).format(date)
        return (
            <span className="date-historic">{current_date}</span>
        )
    }

    historicAction = (historic) => {
        switch (historic.status) {
            case 'up':
                return (<h1 className="action-text">Up par {historic.firstname} {historic.lastname}</h1>)
            case 'down':
                return (<h1 className="action-text">Down par {historic.firstname} {historic.lastname}</h1>)
            case 'activated':
                return (<h1 className="action-text">Activée par {historic.firstname} {historic.lastname}</h1>)
            case 'adresse':
                return (<h1 className="action-text">Adressée à {historic.assignee} par {historic.firstname} {historic.lastname} </h1>)
            case 'create':
                return (<h1 className="action-text">Créée par {historic.firstname} {historic.lastname} </h1>)
            case 'idea':
                return (<h1 className="action-text">Nouvelle idée ajoutée par {historic.firstname} {historic.lastname}</h1>)
            case 'poll':
                return (<h1 className="action-text">Nouveau sondage ajouté par {historic.firstname} {historic.lastname}</h1>)
            case 'accepted':
                return (<h1 className="action-text">Acceptée par {historic.firstname} {historic.lastname}</h1>)
            case 'realized':
                return (<h1 className="action-text">Réalisée par {historic.firstname} {historic.lastname}</h1>)
            case 'reopen':
                return (<h1 className="action-text">Réouverte par {historic.firstname} {historic.lastname}</h1>)
            default:
                return null;
        }
    }


    render() {
        const { historics } = this.state
        return (
            <div className="p-4">
                <h1 className="text-center title-historic mt-5 mb-5">Historique</h1>
                <div className="d-flex pl-5">
                    <div className="blue-line">
                    </div>
                    <div className="box-historic">
                        {historics.map((historic, index) =>
                            (
                                <div className="d-flex justify-content-center mt-3">
                                    <img alt="icon" className="picture-historic" src={historic.picture || DefaultProfileImg} onError={this.props.firebase.profileImgError} />
                                    <div className="ml-3 size-historic" key={index}>
                                        {this.historicDate(historic.date)}
                                        {this.historicAction(historic)}
                                    </div>
                                </div>
                            )
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

const HistoricModalBase = withRouter(withFirebase(HistoricModal));

export default HistoricModalBase;